import React, { Component } from 'react';
import axios from 'axios';

class TrainingIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trainings: [],
            trainers: [],
            testimonials: [],
            loadingTrainings: true,
            loadingTrainers: false,
            loadingTestimonials: false,
            error: null,
            currentTestimonialIndex: 0,
        };
        this._isMounted = false;
        this.trainingsController = null;
        this.trainersController = null;
        this.testimonialsController = null;
        this.testimonialInterval = null;
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchTrainings();
        this.fetchTrainers();
        this.fetchTestimonials();

        // Auto-advance testimonial carousel
        this.testimonialInterval = setInterval(() => {
            if (!this._isMounted) return;
            const { testimonials, currentTestimonialIndex } = this.state;
            if (testimonials.length > 3) {
                const maxIndex = Math.ceil(testimonials.length / 3) - 1;
                const nextIndex = currentTestimonialIndex >= maxIndex ? 0 : currentTestimonialIndex + 1;
                this.setState({ currentTestimonialIndex: nextIndex });
            }
        }, 6000);
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.trainingsController) this.trainingsController.abort();
        if (this.trainersController) this.trainersController.abort();
        if (this.testimonialsController) this.testimonialsController.abort();
        if (this.testimonialInterval) clearInterval(this.testimonialInterval);
    }

    fetchTrainings = () => {
        const token = localStorage.getItem('backend-jwt-token');
        this.trainingsController = new AbortController();

        axios.get('/api/trainings/frontend-list', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.trainingsController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.data) {
                this.setState({
                    trainings: response.data.data,
                    loadingTrainings: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching trainings:', error);
                this.setState({
                    error: 'Failed to load trainings',
                    loadingTrainings: false
                });
            }
        });
    }

    fetchTrainers = () => {
        const token = localStorage.getItem('backend-jwt-token');

        if (!this._isMounted) return;
        this.setState({ loadingTrainers: true });

        this.trainersController = new AbortController();

        axios.get('/api/trainings/trainers/all', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.trainersController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.status === 'success' && response.data.data) {
                this.setState({
                    trainers: response.data.data,
                    loadingTrainers: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching trainers:', error);
                this.setState({
                    loadingTrainers: false
                });
            }
        });
    }

    fetchTestimonials = () => {
        const token = localStorage.getItem('backend-jwt-token');

        if (!this._isMounted) return;
        this.setState({ loadingTestimonials: true });

        this.testimonialsController = new AbortController();

        axios.get('/api/trainings/testimonials/all', {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            signal: this.testimonialsController.signal
        })
        .then(response => {
            if (!this._isMounted) return;
            if (response.data.status === 'success' && response.data.data) {
                this.setState({
                    testimonials: response.data.data,
                    loadingTestimonials: false
                });
            }
        })
        .catch(error => {
            if (!this._isMounted) return;
            if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
                console.error('Error fetching testimonials:', error);
                this.setState({
                    loadingTestimonials: false
                });
            }
        });
    }

    handleViewTraining = (slug) => {
        // Navigate to training detail page using slug
        window.location.href = `/training/${slug}`;
    }

    handleEnrollTraining = (trainingId) => {
        alert('Enrollment functionality coming soon!');
    }

    handleTestimonialDotClick = (index) => {
        this.setState({ currentTestimonialIndex: index });
    }

    renderStars = (rating) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <i key={i} className={`fas fa-star ${i < rating ? '' : 'text-muted'}`}></i>
            );
        }
        return stars;
    }

    render() {
        const { trainings, trainers, testimonials, loadingTrainings, currentTestimonialIndex } = this.state;

        if (loadingTrainings) {
            return (
                <div className="loading-spinner">
                    <p>Loading trainings...</p>
                </div>
            );
        }

        // Pre-compute testimonial pages (3 per page)
        const testimonialsPerPage = 3;
        const totalTestimonialPages = Math.max(1, Math.ceil(testimonials.length / testimonialsPerPage));
        const visibleTestimonials = testimonials.slice(
            currentTestimonialIndex * testimonialsPerPage,
            currentTestimonialIndex * testimonialsPerPage + testimonialsPerPage
        );

        return (
            <div className="training-homepage">
                {/* Hero Section */}
                <section className="hero-section">
                    <div className="container">
                        <div className="hero-wrapper">
                            <div className="hero-content">
                                <h1>
                                    Grow Your Skills in Nepal with Solid Future
                                    <span className="hero-highlight"> &mdash; Shape Your Future Today</span>
                                </h1>
                                <p>
                                    Learn practical skills, gain expert guidance, and start your journey toward a successful future with hands-on training, mentorship, and career opportunities designed just for you.
                                </p>
                                <div className="hero-buttons">
                                    <button className="btn btn-hero-primary">Browse Courses</button>
                                    <button className="btn btn-hero-secondary">Enroll Now</button>
                                </div>
                            </div>
                            <div className="hero-image">
                                <img src="/uploads/trainings/TrainingHero.png" alt="Training" />
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="features-section">
                    <div className="container">
                        <h2 className="section-title">Learn, Grow, and Get Placed with Our Module Program</h2>
                        <div className="features-grid">
                            <div className="feature-box">
                                <div className="feature-icon">
                                    <i className="fas fa-user-tie"></i>
                                </div>
                                <h5>Expert Mentorship</h5>
                                <p>Learn directly from industry professionals.</p>
                            </div>
                            <div className="feature-box">
                                <div className="feature-icon">
                                    <i className="fas fa-graduation-cap"></i>
                                </div>
                                <h5>Practical Skills Training</h5>
                                <p>Hands-on projects to build real-world experience.</p>
                            </div>
                            <div className="feature-box">
                                <div className="feature-icon">
                                    <i className="fas fa-share-alt"></i>
                                </div>
                                <h5>Career Guidance</h5>
                                <p>Personalized support to shape your career path.</p>
                            </div>
                            <div className="feature-box">
                                <div className="feature-icon">
                                    <i className="fas fa-briefcase"></i>
                                </div>
                                <h5>100% Placement Assistance</h5>
                                <p>Get ready for interviews and job opportunities with full placement support.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Unlock Opportunities Section */}
                <section className="unlock-section">
                    <div className="container">
                        <div className="unlock-content">
                            <h2>Unlock New Opportunities Through Our Training</h2>
                            <h6>Find the perfect training to advance your career.</h6>
                            <p>
                                Gain hands-on experience in Digital Marketing, Accounting, HR, Excel, QA, and Job-Oriented programs. Our experienced trainers provide step-by-step guidance to help you master practical skills. Enroll today and take the next step toward your professional growth.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Training Cards List */}
                <section className="trainings-section">
                    <div className="container">
                        {trainings.length > 0 ? (
                            <div className="trainings-list">
                                {trainings.map((training, index) => (
                                    <div key={index} className="training-card">
                                        <div className="training-card-image">
                                            {training.banner_image ? (
                                                <img
                                                    src={`/uploads/trainings/${training.banner_image}`}
                                                    alt={training.title}
                                                />
                                            ) : (
                                                <div className="training-card-placeholder">
                                                    <i className="fas fa-image"></i>
                                                </div>
                                            )}
                                        </div>
                                        <div className="training-card-body">
                                            <h3 className="training-card-title">{training.title}</h3>
                                            <p className="training-card-tagline">{training.tagline}</p>
                                            <p className="training-card-overview">
                                                {training.course_overview && training.course_overview.length > 240
                                                    ? `${training.course_overview.substring(0, 240)}...`
                                                    : training.course_overview}
                                            </p>
                                            <ul className="training-card-features">
                                                <li><i className="fas fa-check-circle"></i> Hands-on Practical Learning</li>
                                                <li><i className="fas fa-check-circle"></i> Expert-Led Sessions</li>
                                                <li><i className="fas fa-check-circle"></i> Comprehensive HR Curriculum</li>
                                                <li><i className="fas fa-check-circle"></i> Career-Boosting Opportunities</li>
                                                <li><i className="fas fa-check-circle"></i> Certification Upon Completion</li>
                                            </ul>
                                            <div className="training-card-buttons">
                                                <button
                                                    className="btn btn-enroll"
                                                    onClick={() => this.handleEnrollTraining(training.id)}
                                                >
                                                    Enroll Now
                                                </button>
                                                <button
                                                    className="btn btn-view"
                                                    onClick={() => this.handleViewTraining(training.slug)}
                                                >
                                                    View Detail
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="no-trainings">
                                <p>No trainings available at the moment</p>
                            </div>
                        )}
                    </div>
                </section>

                {/* Learn From Our Trainers Section */}
                {trainers.length > 0 && (
                    <section className="trainers-section">
                        <div className="container">
                            <h2 className="section-title">Learn From Our Experienced Trainers</h2>
                            <div className="trainers-grid">
                                {trainers.map((trainer, index) => (
                                    <div key={index} className="trainer-card">
                                        <div className="trainer-photo-wrap">
                                            {trainer.photo ? (
                                                <img
                                                    src={`/uploads/emp_img/${trainer.photo}`}
                                                    alt={trainer.name}
                                                    className="trainer-photo"
                                                />
                                            ) : (
                                                <div className="trainer-photo trainer-photo-placeholder">
                                                    <i className="fas fa-user"></i>
                                                </div>
                                            )}
                                        </div>
                                        <div className="trainer-info">
                                            <div className="trainer-name">{trainer.name}</div>
                                            <div className="trainer-designation">{trainer.designation}</div>
                                            <div className="trainer-bio">{trainer.bio || '0+ years of Experience'}</div>
                                            <div className="trainer-social">
                                                {trainer.facebook_url && (
                                                    <a href={trainer.facebook_url} target="_blank" rel="noopener noreferrer" title="Facebook">
                                                        <i className="fab fa-facebook"></i>
                                                    </a>
                                                )}
                                                {trainer.twitter_url && (
                                                    <a href={trainer.twitter_url} target="_blank" rel="noopener noreferrer" title="Twitter">
                                                        <i className="fab fa-twitter"></i>
                                                    </a>
                                                )}
                                                {trainer.linkedin_url && (
                                                    <a href={trainer.linkedin_url} target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                                        <i className="fab fa-linkedin"></i>
                                                    </a>
                                                )}
                                                {trainer.instagram_url && (
                                                    <a href={trainer.instagram_url} target="_blank" rel="noopener noreferrer" title="Instagram">
                                                        <i className="fab fa-instagram"></i>
                                                    </a>
                                                )}
                                                {trainer.whatsapp_number && (
                                                    <a href={`https://wa.me/${trainer.whatsapp_number}`} target="_blank" rel="noopener noreferrer" title="WhatsApp">
                                                        <i className="fab fa-whatsapp"></i>
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                )}

                {/* Why Choose Us Section */}
                <section className="why-choose-section">
                    <div className="container">
                        <h2 className="section-title">Why Choose US ?</h2>
                        <div className="why-choose-grid">
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <i className="fas fa-user-tie"></i>
                                </div>
                                <h6>Industry Expert Trainers</h6>
                                <p>Learn from experienced HR professionals and corporate trainers with years of hands-on expertise in recruitment, HR operations, and management.</p>
                            </div>
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <i className="fas fa-desktop"></i>
                                </div>
                                <h6>Practical &amp; Project-Based Learning</h6>
                                <p>Over 5000+ trainees have successfully completed our courses and are now working with reputed organizations in Nepal and abroad.</p>
                            </div>
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <i className="fas fa-handshake"></i>
                                </div>
                                <h6>Personalized Mentorship</h6>
                                <p>Get one-on-one mentoring to help you clarify your career goals, improve your professional profile, and prepare for real job interviews.</p>
                            </div>
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <i className="fas fa-certificate"></i>
                                </div>
                                <h6>Recognized Certification</h6>
                                <p>Receive an industry-recognized certificate from Solid Future HR Consulting Pvt. Ltd upon successful completion of your training.</p>
                            </div>
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <i className="fas fa-star"></i>
                                </div>
                                <h6>100% Placement Assistance</h6>
                                <p>We don't just train &mdash; we connect you with leading companies and guide you until you secure the right job.</p>
                            </div>
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <i className="fas fa-route"></i>
                                </div>
                                <h6>Proven Career Success</h6>
                                <p>Over 5000+ trainees have successfully completed our courses and are now working with reputed organizations in Nepal and abroad.</p>
                            </div>
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <i className="fas fa-book"></i>
                                </div>
                                <h6>Flexible Learning Options</h6>
                                <p>Join classes online or offline, weekdays or weekends &mdash; designed to fit your schedule and pace.</p>
                            </div>
                            <div className="why-choose-item">
                                <div className="why-choose-icon">
                                    <i className="fas fa-chart-line"></i>
                                </div>
                                <h6>Value for Your Investment</h6>
                                <p>High-quality professional training at reasonable fees with installment and discount options.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Feedback From Our Students Section */}
                {testimonials.length > 0 && (
                    <section className="testimonials-section">
                        <div className="container">
                            <h2 className="section-title">Feedback from Our Students</h2>
                            <div className="testimonials-carousel">
                                <div className="testimonials-grid">
                                    {visibleTestimonials.map((testimonial, index) => (
                                        <div key={index} className="testimonial-card">
                                            <div className="testimonial-header">
                                                {testimonial.student_photo ? (
                                                    <img
                                                        src={`/uploads/trainings/testimonials/${testimonial.student_photo}`}
                                                        alt={testimonial.student_name}
                                                        className="testimonial-avatar"
                                                    />
                                                ) : (
                                                    <div className="testimonial-avatar testimonial-avatar-placeholder">
                                                        <i className="fas fa-user"></i>
                                                    </div>
                                                )}
                                                <div className="testimonial-meta">
                                                    <h6>{testimonial.student_name}</h6>
                                                    <div className="designation">{testimonial.designation}</div>
                                                </div>
                                            </div>
                                            <div className="testimonial-text">
                                                {testimonial.testimonial_text}
                                            </div>
                                            <div className="testimonial-rating">
                                                {this.renderStars(testimonial.rating || 5)}
                                            </div>
                                            {testimonial.training && (
                                                <div className="testimonial-training">
                                                    Completed: {testimonial.training.title}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                {totalTestimonialPages > 1 && (
                                    <div className="testimonial-dots">
                                        {Array.from({ length: totalTestimonialPages }).map((_, idx) => (
                                            <span
                                                key={idx}
                                                className={`testimonial-dot ${idx === currentTestimonialIndex ? 'active' : ''}`}
                                                onClick={() => this.handleTestimonialDotClick(idx)}
                                            ></span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                )}

                {/* Statistics Section */}
                <section className="statistics-section">
                    <div className="container">
                        <h2 className="section-title">Our Impact In Numbers</h2>
                        <div className="stats-grid">
                            <div className="stat-item">
                                <h3>8%</h3>
                                <p>Job Placement Rate</p>
                            </div>
                            <div className="stat-item">
                                <h3>2K</h3>
                                <p>Average Salary Increase</p>
                            </div>
                            <div className="stat-item">
                                <h3>8%</h3>
                                <p>Student Satisfaction</p>
                            </div>
                            <div className="stat-item">
                                <h3>0 Months</h3>
                                <p>Average Time To Employment</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default TrainingIndex;